import { Award, Star, Users } from 'lucide-react';

export default function Mentor() {
  return (
    <section id="mentor" className="py-32 relative overflow-hidden bg-white dark:bg-zinc-950 transition-colors duration-500 border-t border-slate-200 dark:border-white/5">
      {/* Background glow behind image */}
      <div className="absolute top-1/2 left-0 -ml-40 -translate-y-1/2 bg-primary-500/10 dark:bg-primary-500/20 rounded-full w-[600px] h-[600px] blur-[120px] pointer-events-none transition-all duration-500"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">

          {/* Left Side: Portrait */}
          <div className="lg:w-1/2 order-1 lg:order-1 flex justify-center">
            <div className="relative group">
              {/* Organic Animated Shape Background */}
              <div className="absolute inset-0 bg-primary-600 rounded-[30%_70%_70%_30%_/_30%_30%_70%_70%] animate-[morph_8s_ease-in-out_infinite] opacity-10 dark:opacity-20 blur-2xl scale-110 group-hover:scale-125 transition-transform duration-700"></div>

              {/* Photo Frame */}
              <div className="relative w-72 h-72 md:w-96 md:h-96 rounded-[30%_70%_70%_30%_/_30%_30%_70%_70%] animate-[morph_15s_ease-in-out_infinite] border-4 border-[#e00000] shadow-[0_0_50px_rgba(224,0,0,0.3)] dark:shadow-[0_0_70px_rgba(224,0,0,0.2)] overflow-hidden bg-slate-100 dark:bg-zinc-900 group">
                <img src="/aseel.jpg" alt="أصيل العامري" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#e00000]/30 to-transparent mix-blend-multiply opacity-60"></div>
              </div>

              {/* Floating Badge */}
              <div className="absolute bottom-10 right-10 bg-white/90 dark:bg-zinc-800/90 backdrop-blur-md px-6 py-3 rounded-2xl border border-slate-200 dark:border-white/10 shadow-xl flex items-center gap-3 animate-bounce">
                <Star className="w-5 h-5 text-yellow-500 fill-yellow-500" />
                <span className="text-slate-900 dark:text-white font-bold text-lg">مدرب خبير</span>
              </div>
            </div>
          </div>

          {/* Right Side: Content */}
          <div className="lg:w-1/2 order-2 lg:order-2 text-right">
            <h2 className="text-lg font-bold text-primary-600 dark:text-primary-500 mb-3 uppercase tracking-widest inline-flex items-center gap-2 transition-colors duration-500">
              <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
              مدرب الدورة
              <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
            </h2>
            <h3 className="text-4xl md:text-7xl font-extrabold text-slate-900 dark:text-white mb-6 leading-tight transition-colors duration-500">
              أصيل <span className="text-transparent bg-clip-text bg-gradient-to-l from-primary-600 to-primary-700 dark:from-primary-400 dark:to-primary-600">العامري</span>
            </h3>
            <p className="text-xl md:text-2xl font-bold text-slate-700 dark:text-zinc-300 mb-8 transition-colors duration-500">
              مدرب جرافيك خبير ومؤسس عمق ميديا.
            </p>

            <div className="bg-white/50 dark:bg-white/5 backdrop-blur-xl border border-slate-200 dark:border-white/10 rounded-3xl p-8 md:p-10 mb-10 transition-colors duration-500 shadow-sm dark:shadow-none">
              <p className="text-lg md:text-xl text-slate-600 dark:text-zinc-400 leading-relaxed font-medium transition-colors">
                خبرة تتجاوز <span className="text-primary-600 dark:text-primary-500 font-extrabold border-b-2 border-primary-500 pb-1">8 سنوات</span> في مجال تدريب تصميم الجرافيك وصناعة الهوية البصرية. قدمت حلولاً بصرية مبتكرة لمئات الشركات والأفراد، وأسعى من خلال لباب سكول لتمكين المصممين من امتلاك Workflow احترافي يربط الفن بالاستراتيجية.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-center gap-4 justify-end">
                <div className="w-12 h-12 bg-primary-50 dark:bg-primary-500/10 rounded-xl flex items-center justify-center">
                  <Star className="w-6 h-6 text-primary-600 dark:text-primary-500" />
                </div>
                <div className="text-right">
                  <p className="text-2xl font-extrabold text-slate-900 dark:text-white">100+</p>
                  <p className="text-md md:text-lg text-slate-500 dark:text-zinc-500 font-bold">هوية بصرية منجزة</p>
                </div>
              </div>
              <div className="flex items-center gap-4 justify-end">
                <div className="w-12 h-12 bg-primary-50 dark:bg-primary-500/10 rounded-xl flex items-center justify-center">
                  <Users className="w-6 h-6 text-primary-600 dark:text-primary-500" />
                </div>
                <div className="text-right">
                  <p className="text-2xl font-extrabold text-slate-900 dark:text-white">800+</p>
                  <p className="text-md md:text-lg text-slate-500 dark:text-zinc-500 font-bold">طالب تم تدريبه</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        @keyframes morph {
          0% { border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%; }
          33% { border-radius: 70% 30% 50% 50% / 50% 30% 70% 50%; }
          66% { border-radius: 50% 70% 30% 70% / 70% 55% 45% 30%; }
          100% { border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%; }
        }
      `}} />
    </section>
  );
}
